import React, { useState } from 'react';
import {
  Button, TextField, InputAdornment, IconButton,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { PropTypes } from 'prop-types';
import Modal from '../../../../components/Modal/Modal';

const SubjectModalContent = ({ close, onChange, subjectId }) => {
  const [tempSubjectId, setTempSubjectId] = useState(subjectId);
  return (
    <div>
      <TextField
        label="Subject ID"
        sx={{ width: '100%' }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">H3PO</InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="clear subject ID"
                onClick={() => setTempSubjectId('')}
                edge="end"
              >
                {tempSubjectId ? <Close /> : ''}
              </IconButton>
            </InputAdornment>
          ),
        }}
        value={tempSubjectId}
        onChange={(e) => setTempSubjectId(e.target?.value)}
        variant="outlined"
        margin="dense"
      />
      <div style={{ width: '100%', marginBottom: '15px' }}>
        You can find the Subject ID by lorem ipsum dolor sit amet, consectetur
        adipiscing elit. Quisque nisl eros, pulvinar facilisis justo mollis,
        auctor consequat urna.
      </div>
      <div style={{ display: 'flex' }}>
        <div className="responsive-fill" />
        <Button variant="outlined" size="small" onClick={close}>
          Cancel
        </Button>
        <Button
          sx={{ marginLeft: '15px' }}
          variant="contained"
          size="small"
          onClick={() => {
            onChange(tempSubjectId);
            close();
          }}
        >
          Save
        </Button>
      </div>
    </div>
  );
};

SubjectModalContent.propTypes = {
  close: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  subjectId: PropTypes.string.isRequired,
};

export default function SubjectModal({
  showModal,
  setShowModal,
  subjectId,
  setSubjectId,
  close,
}) {
  return (
    <Modal
      isShowing={showModal}
      hide={() => setShowModal(false)}
      showHeader={false}
      innerComponent={(
        <SubjectModalContent
          subjectId={subjectId}
          onChange={(value) => setSubjectId(value || 'Unknown')}
          close={close}
        />
      )}
    />
  );
}

SubjectModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  setShowModal: PropTypes.func.isRequired,
  subjectId: PropTypes.string.isRequired,
  setSubjectId: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
};
